import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import { MyFetch } from "../../App";


const EmployeeDropdown = (props) => {
    const [list_Data, set_List_Data] = useState([])

    useEffect(() => {
        MyFetch("https://easytasks.in/employee/list", {}, "GET")
            .then((res) => res.json())
            .then((data) => set_List_Data(data));
    }, [])

    const renderEmployee = (employee, index) => {
        return (
            <option value={employee.id}> {employee.name} </option>
        )
    };

    return (
            <Form.Select aria-label="Default select example"
                name={props.name}
                value={props.value}
                onChange={props.onChange}
            >
                <option>Select employee</option>
                {list_Data && list_Data.length > 0 ? list_Data.map(renderEmployee) : <></>}
            </Form.Select>
    )
}

export default EmployeeDropdown;